<template>
  <PersonalAreaTemplate :editing="editing">
    <div class="d-grid gap-5">
      <!-- <h6 class="f18 fw500 mb-5" v-if="$vuetify.breakpoint.mdAndUp">
        {{ localStorage.translations.pages['setting-personal_area'].sections['navyki'] }}
      </h6> -->
      <div class="skills_table">
        <div class="skills_table_head">
          {{ localStorage.translations.pages['setting-personal_area'].labels['vid-rabot'] }}
        </div>
        <div class="skills_table_item" v-if="!skills.length && !checkData.skillsPick.length">
          <span class="f14">{{ localStorage.translations.pages.common.text['net-dannyh'] }}</span>
        </div>
        <div class="skills_table_item" v-for="(i, index) in checkData.skillsPick" :key="index">
          <span class="f14">{{ i.name }}</span>
          <DeleteBtn :deleteItem="deleteItem" :deleteItemIndex="index" v-if="editing" />
        </div>
        <div class="skills_table_add" v-if="editing">
          <div class="input">
            <BaseInput
              type="autocomplete"
              v-model="skillsSelected"
              :items="onSkillsNoUse(checkData.skillsPick, workTypeGridAll)"
              :item-value="(i) => i"
              :item-text="(i) => i.name"
              prepend-inner-icon="search"
              chips
              small-chips
              multiple
            />
          </div>
          <div class="button">
            <BaseButton
              @click="skillsConcat"
              :text="localStorage.translations.pages['setting-personal_area'].buttons['dobavit']"
              default_icon="button-add"
            />
            <BaseButton
              v-if="
                modal &&
                JSON.stringify(skills.map((i) => i.id)) !==
                  JSON.stringify(checkData.skillsPick.map((i) => i.id))
              "
              @click="saveChange"
              :text="localStorage.translations.pages['setting-personal_area'].buttons['sohranit']"
              default_icon="button-save"
            />
          </div>
        </div>
      </div>
    </div>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import DeleteBtn from 'components/DeleteBtn'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
export default {
  name: 'Skills',
  props: {
    editing: Boolean,
    skills: [Array, Object],
    employeeId: [String, Number],
    modal: Boolean,
    onDownloadPageData: Function,
  },
  components: { DeleteBtn, PersonalAreaTemplate },
  data: () => ({
    checkData: {
      skillsPick: [],
    },
    skillsSelected: [],
  }),
  created() {
    if (this.editing) {
      this.onWorkTypeGridAll()
    }
    this.onActualData()
  },
  watch: {
    editing() {
      if (this.editing) {
        this.onWorkTypeGridAll()
      }
    },
    skills() {
      this.onActualData()
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { skills: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    workTypeGridAll() {
      return this.$store.getters['workType/workTypeGridAll']
    },
  },
  methods: {
    ...mapActions('user', ['onUserUpdateEmployeeData']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    ...mapActions('navigationGuardian', [
      'onNavigationGuardianCheck',
      'offNavigationGuardianCheck',
    ]),
    onActualData() {
      this.checkData.skillsPick = this.skills.slice(0)
      this.onNavigationGuardianCheck({
        data: { skills: this.checkData },
        overwrite: true,
      })
    },
    diff(a, b) {
      if (a.length > b.length) {
        return _.difference(a, b)
      } else {
        return _.difference(b, a)
      }
    },
    onWorkTypeGridAll() {
      this.$store.dispatch('workType/onWorkTypeGridAll')
    },
    deleteItem(index) {
      this.checkData.skillsPick.splice(index, 1)
    },
    onSkillsNoUse(a, b) {
      var onlyInA = a.filter(this.comparer(b))
      var onlyInB = b.filter(this.comparer(a))
      let result = onlyInA.concat(onlyInB)
      return result
    },
    onSkillsPickId() {
      return this.checkData.skillsPick.map((i) => i.id)
    },
    comparer(otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return other.id == current.id && other.name == current.name
          }).length == 0
        )
      }
    },

    skillsConcat() {
      let skills = Array.from(new Set(this.checkData.skillsPick.concat(this.skillsSelected)))
      this.checkData.skillsPick = skills.filter((i) => i).sort()
      this.skillsSelected = []
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('skills')) {
          let data = {
            work_types: this.onSkillsPickId(),
          }
          if (this.modal) {
            data.id = this.employeeId
            await this.onEmployeeUpdate(data)
              .then((result) => {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },
                  { root: true },
                )
                this.offNavigationGuardianCheck()
                if (this.onDownloadPageData) {
                  this.onDownloadPageData()
                }
              })
              .catch((err) => {})
          }
          resolve(data)
        } else resolve(true)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.skills {


  &_table {
    //margin: 0 -30px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin: 0;
    }
    &_head {
      padding: 20px 30px;
      background-color: #efefef;
      color: #333333;
      font-weight: 500;
      font-size: 14px;
    }
    &_item {
      // padding: 20px 30px;
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #bedbeb;
      padding: 20px 30px;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        padding: 10px;
      }
    }
    &_add {
      border-top: 1px solid #277faf;
      padding: 20px 30px 0;
      display: grid;
      gap: 20px;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        padding: 20px 10px 0;
      }
      .button {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
      }
    }
  }
}
</style>
